import {
  LayoutDashboard,
  MapPin,
  Sheet,
  Shield,
  CheckCircle,
  Trash2,
  Package,
  Eye,
  Globe,
  Settings,
} from "lucide-react";
import { LayoutConfig } from "../../components/layout/types";

export const adminLayoutConfig: LayoutConfig = {
  brandName: "Gedoba",
  brandSubtitle: "Admin Panel",
  sidebarWidth: 288, // 72 * 4 = 288px (w-72.5 equivalent)
  headerHeight: "4rem",
  showLocationDropdown: false,
  showSearchBar: true,
  searchPlaceholder: "Search admin...",
  showViewSwitcher: false,
  menuSections: [
    {
      label: "",
      defaultOpen: true,
      items: [
        {
          icon: LayoutDashboard,
          label: "Analytics",
          path: "/admin",
          color: "text-blue-600",
        },
        {
          icon: Sheet,
          label: "Users",
          path: "/admin/users",
          color: "text-green-600",
        },
        {
          icon: Shield,
          label: "Permissions",
          path: "/admin/permissions",
          color: "text-purple-600",
        },
        {
          icon: Globe,
          label: "Registration Domains",
          path: "/admin/domains",
          color: "text-indigo-600",
        },
        {
          icon: MapPin,
          label: "Geo-Blocking",
          path: "/admin/geoblocking",
          color: "text-red-500",
        },
        {
          icon: CheckCircle,
          label: "Approvals",
          path: "/admin/approvals",
          color: "text-orange-600",
        },
        {
          icon: Trash2,
          label: "Recycle Bin",
          path: "/admin/recycle-bin",
          color: "text-red-600",
        },
        {
          icon: MapPin,
          label: "Locations",
          path: "/admin/locations",
          color: "text-teal-600",
        },
        {
          icon: Package,
          label: "Location Types",
          path: "/admin/location-types",
          color: "text-cyan-600",
        },
        {
          icon: Eye,
          label: "Section Visibility",
          path: "/admin/section-visibility",
          color: "text-blue-600",
        },
        {
          icon: Settings,
          label: "Global Settings",
          path: "/admin/global-settings",
          color: "text-slate-600",
        },
      ],
    },
  ],
};
